module.exports = __webpack_public_path__ + "static/media/default_tooltip_help_icon.726c696a.svg";